var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { OnInit, ElementRef, Renderer2, ChangeDetectorRef, OnDestroy } from '@angular/core';
import { Store, Select, Actions, ofActionDispatched, ofActionCompleted } from '@ngxs/store';
import { SetReady, SetEngineChapterInit, SynchronizeVisibleNodes, SetEngineChapter, ClickNode, FlyToObject, SynchronizeRenderableNodes, PlayAnimation, ShowScrollAlert } from '../../state/engine.actions';
import { EngineState } from '../../state/engine.state';
import { Observable, fromEvent, BehaviorSubject, combineLatest, Subject, interval, merge } from 'rxjs';
import { filter, takeUntil, bufferTime, debounceTime, throttle, pairwise } from 'rxjs/operators';
import { EngineService } from '../../engine.service';
import { environment } from 'src/environments/environment';
import { CameraService } from '../../camera.service';
import { EngineVisibilityEnum } from '../../models/engine-visibility.enum';
import { ToolEnum } from 'src/app/engine/models/tool.enum';
import { StoryChaptersState } from 'src/app/story/state/chapters/story.chapters.state';
import { PaintService } from '../../paint.service';
import { SetCamera, MoveCamera, PanCameraStatic, RotateCameraStatic, ZoomCameraStatic } from '../../state/camera/engine.camera.actions';
import { CameraMotionModel } from '../../models/camera-motion.model';
import { EngineCameraState } from '../../state/camera/engine.camera.state';
import { AnimationService } from '../../animation.service';
import { BackgroundModel } from '../../models/background.model';
import { HoverNode, UnpaintNodes } from '../../state/nodes/engine.nodes.actions';
import { EngineNodesState } from '../../state/nodes/engine.nodes.state';
import { get, isEmpty } from 'lodash';
import * as Hammer from 'hammerjs';
import { EventsEnum } from '../../models/events.enum';
import { StoryState } from 'src/app/story/state/story.state';
import { SetProgress } from '../../state/progress/engine.progress.actions';
import { LoadStoryChunkSuccess } from 'src/app/story/state/story.actions';
import { BdGraphService } from 'src/lib/graph/graph.service';
import { PaintPresetFade } from '../../models/paint-presets.const';
import { ScrollModeEnum } from '../../models/scroll-mode.enum';
import { disableXrayMode } from 'src/app/shared/xray-mode';
import { EnvironmentApplication } from 'src/environments/models/environment-application';
var KeyboardCamera;
(function (KeyboardCamera) {
    KeyboardCamera[KeyboardCamera["Pan"] = 0.4] = "Pan";
    KeyboardCamera[KeyboardCamera["PanSlow"] = 0.04] = "PanSlow";
    KeyboardCamera[KeyboardCamera["Zoom"] = 5] = "Zoom";
    KeyboardCamera[KeyboardCamera["ZoomSlow"] = 1] = "ZoomSlow";
    KeyboardCamera[KeyboardCamera["Rotate"] = 0.3] = "Rotate";
    KeyboardCamera[KeyboardCamera["RotateSlow"] = 0.03] = "RotateSlow";
})(KeyboardCamera || (KeyboardCamera = {}));
var MouseCamera;
(function (MouseCamera) {
    MouseCamera[MouseCamera["Rotate"] = 6] = "Rotate";
    MouseCamera[MouseCamera["Pan"] = 1.75] = "Pan";
    MouseCamera[MouseCamera["Zoom"] = 2] = "Zoom";
})(MouseCamera || (MouseCamera = {}));
var TouchCamera;
(function (TouchCamera) {
    TouchCamera[TouchCamera["Zoom"] = -12] = "Zoom";
    TouchCamera[TouchCamera["Pan"] = 2.5] = "Pan";
    TouchCamera[TouchCamera["Rotate"] = 1.5] = "Rotate";
    TouchCamera[TouchCamera["Pinch"] = 1.5] = "Pinch";
})(TouchCamera || (TouchCamera = {}));
var CursorClasses;
(function (CursorClasses) {
    CursorClasses["Hide"] = "engine--cursor-hide";
    CursorClasses["Label"] = "engine--cursor-label";
    CursorClasses["Paint"] = "engine--cursor-paint";
    CursorClasses["Crosshair"] = "engine--cursor-crosshair";
    CursorClasses["Default"] = "";
})(CursorClasses || (CursorClasses = {}));
var MouseButtons;
(function (MouseButtons) {
    MouseButtons[MouseButtons["None"] = 0] = "None";
    MouseButtons[MouseButtons["Left"] = 1] = "Left";
    MouseButtons[MouseButtons["Right"] = 2] = "Right";
    MouseButtons[MouseButtons["LeftAndRight"] = 4] = "LeftAndRight";
})(MouseButtons || (MouseButtons = {}));
var zoomVelocity = 10;
var EngineComponent = /** @class */ (function () {
    function EngineComponent(actions, animationService, cameraService, changeDetecton, engineEventsService, paintService, renderer, store, graphService) {
        this.actions = actions;
        this.animationService = animationService;
        this.cameraService = cameraService;
        this.changeDetecton = changeDetecton;
        this.engineEventsService = engineEventsService;
        this.paintService = paintService;
        this.renderer = renderer;
        this.store = store;
        this.graphService = graphService;
        this.flyCamera = true;
        this.chapterActivating = false;
        this.visible = false;
        this.cursorClass = CursorClasses.Default;
        this.mouseDelta = null;
        this.ngUnsubscribe = new Subject();
        this.hoveredNode = null;
        this.display = false;
        this.engineVisible = true;
        this.ctrlPressed = false;
        this.scrollType = null;
        this.scrollTimeout = null;
        this.zoomVelocity = 0;
        this.inputEnabled = true;
    }
    Object.defineProperty(EngineComponent.prototype, "isTransparentBackground", {
        get: function () {
            if (this.background) {
                return BackgroundModel.isTransparent(this.background);
            }
            else {
                return false;
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EngineComponent.prototype, "isBackgroundCheckered", {
        get: function () {
            return environment.application !== EnvironmentApplication.Viewer && this.isTransparentBackground;
        },
        enumerable: true,
        configurable: true
    });
    EngineComponent.prototype.wheel = function (event) {
        var scrollMode = this.store.selectSnapshot(EngineState.getScrollMode);
        var ctrlActive = this.ctrlPressed;
        if (scrollMode === ScrollModeEnum.DoNotCaptureShowMessage && !ctrlActive) {
            this.store.dispatch(new ShowScrollAlert(true));
        }
        if (scrollMode !== ScrollModeEnum.Capture && !ctrlActive) {
            return;
        }
        // if we're allowed to scroll, we never want the parent window to scroll
        event.preventDefault();
        this.handleWheel(event);
    };
    EngineComponent.prototype.contextmenu = function (event) {
        this.handleContextMenu(event);
    };
    EngineComponent.prototype.mouseout = function () {
        this.handleMouseOut();
    };
    // map single property state map to graph state map
    EngineComponent.prototype.convertToLeafStateMap = function (property, propertyMap) {
        var leafStateMap = {};
        Object.entries(propertyMap).forEach(function (_a) {
            var _b = __read(_a, 2), id = _b[0], state = _b[1];
            leafStateMap[id] = {};
            leafStateMap[id][property] = state;
        });
        return leafStateMap;
    };
    EngineComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.bindEngineEvents();
        this.bindApplicationEvents();
        this.bindUserEvents();
        this.bindKeyEvents();
        this.bindHumanInteractions();
        this.renderer.listen(window, 'keydown', function (e) {
            if (e.key === 'Control') {
                _this.ctrlPressed = true;
            }
        });
        this.renderer.listen(window, 'keyup', function (e) {
            if (e.key === 'Control') {
                _this.ctrlPressed = false;
            }
        });
        Human.properties.set({ assetDomain: environment.assetDomain });
        Human.workers.setPath('/assets/engine/studio/workers');
        Human.init.init();
    };
    EngineComponent.prototype.ngOnDestroy = function () {
        this.changeDetecton.detach();
        this.ngUnsubscribe.next();
        this.ngUnsubscribe.complete();
    };
    EngineComponent.prototype.initEventListeners = function () {
    };
    EngineComponent.prototype.bindEngineEvents = function () {
        var _this = this;
        // Graph has initialized
        this.engineEventsService.getEvent(EventsEnum.Loaded)
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe(function () {
            _this.store.dispatch(new SetReady(true));
        });
        // Chapters have started activating
        this.engineEventsService.getEvent(EventsEnum.TimelineChaptersActivateStart)
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe(function () {
            _this.chapterActivating = true;
        });
        // Chapters have finished
        this.engineEventsService.getEvent(EventsEnum.TimelineChaptersActivateFinish)
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe(function (params) {
            _this.chapterActivating = false;
            var currentBranch = Human.timeline.activeRoot._nowBranch;
            var chapterInit = {
                id: currentBranch.id,
                init: true,
                camera: currentBranch.initializedCamera,
                annotations: currentBranch.initializedAnnotations,
                graph: currentBranch.initializedGraph,
                properties: currentBranch.initializedProperties,
                particles: currentBranch.initializedParticles,
                clips: currentBranch.initializedClippingPlanes,
                postprocessing: currentBranch.initializedPostprocess,
                transparency: currentBranch.initializedTransparencyMode
            };
            _this.store.dispatch(new SetEngineChapter(params.chapterId));
            _this.store.dispatch(new SetEngineChapterInit(chapterInit));
        });
        // Handle engine tick, but only when it's visible
        this.engineEventsService.getEvent(EventsEnum.Tick)
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe(function () {
            if (_this.visible) {
                if (_this.inputEnabled) {
                    _this.handleMouseInputEngineTick();
                }
                _this.handleCameraTick();
            }
        });
        // Handle object visibility event
        this.engineEventsService.getEvent(EventsEnum.SceneObjectsShown)
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe(function (params) {
            if (!_this.chapterActivating) {
                var stateMap = _this.convertToLeafStateMap('shown', params.enabledObjectsUpdate);
                _this.store.dispatch(new SynchronizeVisibleNodes(stateMap));
            }
        });
        // Handle object renderable event
        this.engineEventsService.getEvent(EventsEnum.SceneObjectRenderable)
            .pipe(bufferTime(1000), takeUntil(this.ngUnsubscribe))
            .subscribe(function (renderable) {
            if (renderable.length) {
                var leafStateMap_1 = {};
                renderable.forEach(function (renderableData) {
                    leafStateMap_1[renderableData.objectId] = { 'renderable': true };
                });
                _this.store.dispatch(new SynchronizeRenderableNodes(leafStateMap_1));
            }
        });
        // Handle Loading
        this.engineEventsService
            .getEvent(EventsEnum.AssetsLoadProgress)
            .pipe(takeUntil(this.ngUnsubscribe), throttle(function () { return interval(250); }))
            .subscribe(function (progress) {
            var totalChunks = _this.store.selectSnapshot(StoryState.getLoadChunks).length;
            var remainingChunks = _this.store.selectSnapshot(StoryState.getLoadChunksRemaining).length;
            var currentChunkIdx = totalChunks - remainingChunks;
            var receivedAssets = progress.receivedAssets, requestedAssets = progress.requestedAssets;
            var currentChunkProgress = receivedAssets / requestedAssets;
            var chunkWidth = 1 / totalChunks;
            var baseProgress = currentChunkIdx * chunkWidth;
            var currentProgress = currentChunkProgress * chunkWidth;
            var storyLoadProgress = currentProgress + baseProgress;
            _this.store.dispatch(new SetProgress(storyLoadProgress, currentChunkProgress));
        });
        // There are story load chunks that don't actually initiate any downloading.
        // Therefore, we can only know when loading has completed by pipeing LoadStoryChunkSuccess, and there are zero chunks remaining
        this.actions
            .pipe(ofActionCompleted(LoadStoryChunkSuccess), takeUntil(this.ngUnsubscribe))
            .subscribe(function () {
            var chunksRemaining = _this.store.selectSnapshot(StoryState.getLoadChunksRemaining).length;
            if (chunksRemaining === 0) {
                _this.store.dispatch(new SetProgress(1, 1));
            }
        });
        // timeline: playing
        this.engineEventsService.getEvent(EventsEnum.TimelinePlayed)
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe(function () {
            _this.store.dispatch(new PlayAnimation(true));
        });
        // timeline: stopped
        merge(this.engineEventsService.getEvent(EventsEnum.TimelinePaused), this.engineEventsService.getEvent(EventsEnum.TimelineStopped))
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe(function () {
            _this.store.dispatch(new PlayAnimation(false));
        });
    };
    EngineComponent.prototype.highlightXrayMode = function (checkedNodes) {
        var _this = this;
        var viewGraph = this.store.selectSnapshot(EngineState.getViewGraph);
        var uncheckedNodeIds = this.graphService.getInverseSelection(viewGraph, checkedNodes.map(function (node) { return node.id; }));
        var uncheckedNodes = this.graphService.getNodes(viewGraph, uncheckedNodeIds);
        uncheckedNodes.forEach(function (node) { return _this.paintService.paint(node, PaintPresetFade.recipe); });
        this.store.dispatch(new UnpaintNodes(checkedNodes));
    };
    EngineComponent.prototype.highlightDefaultMode = function (checkedNodes, uncheckedNodes) {
        this.paintService.highlightAll(uncheckedNodes, false);
        this.paintService.highlightAll(checkedNodes, true);
    };
    EngineComponent.prototype.bindApplicationEvents = function () {
        var _this = this;
        // Available screen space for the engine has changed
        this.enginePosition$
            .pipe(filter(function (position) { return position != null; }), takeUntil(this.ngUnsubscribe))
            .subscribe(function (position) {
            _this.repositionEngine(position);
        });
        this.checkedNodes$
            .pipe(takeUntil(this.ngUnsubscribe), pairwise())
            .subscribe(function (nodes) {
            var _a = __read(nodes, 2), previouslySelected = _a[0], currentlySelected = _a[1];
            if (_this.store.selectSnapshot(EngineState.getXrayModeEnabled)) {
                _this.highlightXrayMode(currentlySelected);
            }
            else {
                _this.highlightDefaultMode(currentlySelected, previouslySelected);
            }
            // notify selection updates
            var selectedObjectsUpdate = _this.calculateSelectedObjectsUpdate(previouslySelected || [], currentlySelected || []);
            // only fire the event if there is an updated
            if (!isEmpty(selectedObjectsUpdate)) {
                _this.engineEventsService.fireEvent(EventsEnum.SceneObjectsSelected, { selectedObjectsUpdate: selectedObjectsUpdate });
            }
        });
        this.store.select(EngineState.getXrayModeEnabled)
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe(function (xrayModeEnabled) {
            // get checked and unchecked nodes.
            var checkedNodes = _this.store.selectSnapshot(EngineNodesState.getCheckedNodes);
            // when toggling xray mode,
            // we have to refresh the way objects are presented, based on the currently selected nodes.
            if (xrayModeEnabled === false) {
                // re-paint leaf nodes
                _this.store.selectSnapshot(EngineState.getXrayCachedColorRecipes).forEach(function (recipe) { return _this.paintService.colorObject(recipe.objectId, recipe.recipe); });
                // re-highlight checked nodes
                _this.highlightDefaultMode(checkedNodes, []);
            }
            else { // xray mode is enabled
                // turn off the highlighting for the checked nodes
                _this.paintService.highlightAll(checkedNodes, false);
                // highlight xray mode for checked nodes.
                _this.highlightXrayMode(checkedNodes);
            }
        });
        this.actions.pipe(ofActionDispatched(SetCamera), takeUntil(this.ngUnsubscribe)).subscribe(function (action) {
            return action.animate
                ? _this.flyToPoint(action.camera, action.animationDuration)
                : _this.jumpToPoint(action.camera);
        });
        this.actions.pipe(ofActionDispatched(PanCameraStatic), takeUntil(this.ngUnsubscribe)).subscribe(function (action) {
            _this.cameraService.panCameraStatic(action.x, action.y, action.z);
        });
        this.actions.pipe(ofActionDispatched(RotateCameraStatic), takeUntil(this.ngUnsubscribe)).subscribe(function (action) {
            _this.cameraService.rotateCameraStatic(action.x, action.y);
        });
        this.actions.pipe(ofActionDispatched(ZoomCameraStatic), takeUntil(this.ngUnsubscribe)).subscribe(function (action) {
            _this.cameraService.setHumanZoomFactor(action.value);
        });
        this.actions.pipe(ofActionDispatched(FlyToObject), filter(function (action) { return !!action.objectId; }), takeUntil(this.ngUnsubscribe)).subscribe(function (action) {
            action.animate
                ? _this.flyToObject(action.objectId, action.animationDuration)
                : _this.jumpToObject(action.objectId);
        });
        // New chapter
        this.selectedChapter$
            .pipe(filter(function (chapter) {
            return chapter != null;
        }), takeUntil(this.ngUnsubscribe))
            .subscribe(function (chapter) {
            // xray mode needs to be disabled when changing chapter
            disableXrayMode(_this.store, _this.engineEventsService);
            // set background
            _this.background = _this.store.selectSnapshot(StoryChaptersState.getSelectedChapterBackground);
            Human.timeline.scrub({ chapterId: chapter.id });
        });
        this.background$
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe(function (background) {
            _this.background = background;
        });
        // Selected tool changed
        this.activeTool$
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe(function (tool) {
            // Reset hover class
            Object.values(CursorClasses).forEach(function (cursorClass) {
                if (cursorClass) {
                    _this.renderer.removeClass(_this.engineElement.nativeElement, cursorClass);
                }
            });
            switch (tool) {
                case ToolEnum.Hide:
                    _this.renderer.addClass(_this.engineElement.nativeElement, CursorClasses.Hide);
                    break;
                case ToolEnum.Label:
                    _this.renderer.addClass(_this.engineElement.nativeElement, CursorClasses.Label);
                    break;
                case ToolEnum.Paint:
                    _this.renderer.addClass(_this.engineElement.nativeElement, CursorClasses.Paint);
                    break;
                case ToolEnum.Isolate:
                case ToolEnum.Fade:
                    _this.renderer.addClass(_this.engineElement.nativeElement, CursorClasses.Crosshair);
                    break;
                default:
                    // Do nothing for now
                    break;
            }
        });
        // Chapter animation
        combineLatest(this.selectedChapter$, this.animationPlaying$)
            .pipe(filter(function (_a) {
            var _b = __read(_a, 1), chapter = _b[0];
            return chapter != null;
        }), takeUntil(this.ngUnsubscribe))
            .subscribe(function (_a) {
            var _b = __read(_a, 2), chapter = _b[0], playing = _b[1];
            var playCount = get(chapter, 'ui.play.count') || 0;
            if (_this.animationService.isChapterAnimated(chapter) && chapter.readyState.animation && playing) {
                _this.animationService.play({
                    startChapterId: chapter.id,
                    loop: (playCount === -1),
                    numChapters: 1,
                    queue: false // True for higher playcount
                });
            }
            else {
                _this.animationService.pause();
            }
        });
        // display
        this.engineDisplay$
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe(function (display) {
            _this.display = display;
            _this.changeDetecton.markForCheck();
        });
        // visibility
        this.engineVisible$
            .pipe(takeUntil(this.ngUnsubscribe))
            .subscribe(function (visible) {
            _this.engineVisible = visible;
            _this.changeDetecton.markForCheck();
        });
    };
    EngineComponent.prototype.bindUserEvents = function () {
        var _this = this;
        // User moves mouse, debounce to small delay so lookup only occurs on pause.
        // Done for performance, doing a node lookup in 3D is expensive.
        this.mouseMove$ = fromEvent(this.engineElement.nativeElement, 'mousemove');
        // Handle all mouse move events, primarily for panning the camera
        this.mouseMove$.pipe(takeUntil(this.ngUnsubscribe)).subscribe(function (event) {
            _this.handleMousePan(event);
        });
        // User moves mouse, debounce to small delay so  hover lookup only occurs on pause.
        // Done for performance, doing a node lookup in 3D is expensive.
        this.mouseMove$.pipe(debounceTime(10), takeUntil(this.ngUnsubscribe)).subscribe(function (event) {
            _this.handleMouseHover(event);
        });
    };
    EngineComponent.prototype.bindKeyEvents = function () {
        var _this = this;
        var downKeys = ['w', 'a', 's', 'd', 'e', 'c', '=', '-', '+', '_', 'arrowleft', 'arrowright', 'arrowup', 'arrowdown', 'shiftKey']
            .reduce(function (result, value) {
            result[value] = false;
            return result;
        }, {});
        var downKeys$ = new BehaviorSubject(downKeys);
        this.renderer.listen(window, 'keydown', function (event) {
            var _a;
            if (event.repeat || event.metaKey || event.ctrlKey) {
                return;
            }
            // Prevent keyboard events while inputs are focused
            var eventNode = event.target.nodeName.toLowerCase();
            if (['input', 'textarea', 'select', 'option'].indexOf(eventNode) >= 0) {
                return;
            }
            downKeys$.next(__assign({}, downKeys$.value, (_a = {}, _a[event.key.toLowerCase()] = true, _a.shiftKey = event.shiftKey, _a)));
        });
        this.renderer.listen(window, 'keyup', function (event) {
            var _a;
            if (event.key) {
                downKeys$.next(__assign({}, downKeys$.value, (_a = {}, _a[event.key.toLowerCase()] = false, _a.shiftKey = event.shiftKey, _a)));
            }
        });
        downKeys$
            .pipe(
        // validate input enabled state
        filter(function () { return _this.inputEnabled; }), takeUntil(this.ngUnsubscribe))
            .subscribe(function (value) {
            var motion = new CameraMotionModel();
            var zoom = value.shiftKey ? KeyboardCamera.ZoomSlow : KeyboardCamera.Zoom;
            var pan = value.shiftKey ? KeyboardCamera.PanSlow : KeyboardCamera.Pan;
            var rotate = value.shiftKey ? KeyboardCamera.RotateSlow : KeyboardCamera.Rotate;
            motion.zoom += (value.c || value['-'] || value['_']) ? zoom : 0;
            motion.zoom -= (value.e || value['='] || value['+']) ? zoom : 0;
            motion.panX -= value.d ? pan : 0;
            motion.panX += value.a ? pan : 0;
            motion.panY += value.w ? pan : 0;
            motion.panY -= value.s ? pan : 0;
            motion.rotateX -= value.arrowright ? rotate : 0;
            motion.rotateX += value.arrowleft ? rotate : 0;
            motion.rotateY += value.arrowup ? rotate : 0;
            motion.rotateY -= value.arrowdown ? rotate : 0;
            _this.store.dispatch(new MoveCamera(motion));
        });
    };
    EngineComponent.prototype.repositionEngine = function (position) {
        this.renderer.setStyle(this.engineElement.nativeElement, 'left', position.left + "px");
        this.renderer.setStyle(this.engineElement.nativeElement, 'top', position.top + "px");
        this.renderer.setStyle(this.engineElement.nativeElement, 'width', position.width + "px");
        this.renderer.setStyle(this.engineElement.nativeElement, 'height', position.height + "px");
        this.renderer.setStyle(this.engineElement.nativeElement, 'zIndex', "" + position.visibility);
        this.renderer.setStyle(this.engineElement.nativeElement, 'visibility', (position.visibility === EngineVisibilityEnum.Shown) ? 'visible' : 'hidden');
        // Engine user interaction will be disabled when the engine isn't visible
        this.visible = position.visibility === EngineVisibilityEnum.Shown;
        Human.renderer.resize();
    };
    /**
     * User Interactions
     * Depends on the HammerJS library to ensure touch compatibility, and manage pan handlers (heh...)
     */
    EngineComponent.prototype.bindHumanInteractions = function () {
        var _this = this;
        // Create a HammerJS manager so we can custom define single and double click
        var mc = new Hammer.Manager(this.engineCanvasElement.nativeElement);
        // Tap recognizer with minimal 2 taps
        mc.add(new Hammer.Tap({ event: 'doubletap', taps: 2 }));
        // Single tap recognizer
        mc.add(new Hammer.Tap({ event: 'singletap' }));
        // Pan recognizer
        mc.add(new Hammer.Pan({ event: 'pan', pointers: 0 }));
        // Ping
        mc.add(new Hammer.Pinch());
        // Press
        mc.add(new Hammer.Press({ time: 500 }));
        mc.on('singletap', function (event) {
            _this.handleTap(event);
        });
        mc.on('doubletap', function (event) {
            _this.handleDoubleTap(event);
        });
        mc.on('press', function (event) {
            _this.handlePress(event);
        });
        mc.on('pan', function (event) {
            event.preventDefault();
            _this.handlePan(event);
        });
        var cacheScale = 0;
        var cacheX = 0;
        var cacheY = 0;
        var mode = '';
        mc.on('pinchstart', function (event) {
            cacheScale = event.scale;
            cacheX = event.deltaX;
            cacheY = event.deltaY;
            mode = '';
        });
        mc.on('pinchmove', function (event) {
            var panDistanceMet = Math.abs(event.deltaX) > 15 || Math.abs(event.deltaY) > 15;
            var pinchScaleMet = event.scale > 1.1 || event.scale < 0.9;
            // Determine is user is panning or pinching
            if (!mode) {
                mode = panDistanceMet ? 'pan' : 'pinch';
            }
            else {
                if (mode === 'pan' && pinchScaleMet && !panDistanceMet) {
                    mode = 'pinch';
                }
                if (mode === 'pinch' && panDistanceMet && !pinchScaleMet) {
                    mode = 'pan';
                }
            }
            var scale = event.scale - cacheScale;
            cacheScale = event.scale;
            switch (mode) {
                case 'pan':
                    _this.cameraService.setCameraPan(event.velocityX, event.velocityY * TouchCamera.Pinch);
                    break;
                case 'pinch':
                    Human.renderer.camera.zoom(scale * TouchCamera.Zoom);
                    break;
                default:
                    _this.cameraService.setCameraPan(event.velocityX, event.velocityY * TouchCamera.Pinch);
                    Human.renderer.camera.zoom(scale * TouchCamera.Zoom);
            }
        });
    };
    EngineComponent.prototype.handleMouseHover = function (event) {
        if (event.buttons !== MouseButtons.None) {
            return;
        }
        var offsetX = event.offsetX, offsetY = event.offsetY;
        var hit = Human.renderer.pick.pick(offsetX, offsetY);
        if (hit.objectId) {
            var viewGraph = this.store.selectSnapshot(EngineState.getViewGraph);
            var hitNode = this.engineEventsService.getNode(viewGraph, hit.objectId);
            var hoveredNode = this.store.selectSnapshot(EngineNodesState.getHoveredNode);
            if (!hoveredNode || hoveredNode.id !== hitNode.id) {
                this.store.dispatch(new HoverNode(hitNode, hit));
            }
        }
        else {
            if (this.store.selectSnapshot(EngineNodesState.getHoveredNode) != null) {
                this.store.dispatch(new HoverNode(null));
            }
        }
    };
    EngineComponent.prototype.handleMousePan = function (event) {
        // Left mouse button is handled by HammerJS 'pan'
        if (event.buttons === 2 || event.buttons === 4) {
            var movementX = event.movementX, movementY = event.movementY;
            movementX /= 20;
            movementY /= 20;
            this.cameraService.setCameraPan(movementX, movementY);
        }
    };
    EngineComponent.prototype.handleMouseOut = function () {
        this.store.dispatch(new HoverNode(null));
    };
    // When it comes to wheel events, we account for both trackpad and scroll wheel. The deltaY
    // from these events can vary wildly between trackpad, mouse type, and browser. Read the docs
    // below to learn more.
    // https://developer.mozilla.org/en-US/docs/Web/API/WheelEvent
    EngineComponent.prototype.handleWheel = function (event) {
        var _this = this;
        var deltaY = 0;
        // Check deltaMode, which determines if we're pixel / line / page scrolling
        switch (event.deltaMode) {
            case 0: // Pixel delta (most common, trackpad and mice scroll wheels in Chrome & Safari)
                // Best attempt at determining trackpad vs wheel. 
                // On initial scroll, a trackpad never starts off higher than 10 pixels movement.
                if (this.scrollType === null) {
                    this.scrollType = (Math.abs(event.deltaY) < 10) ? 'trackpad' : 'wheel';
                }
                // If trackpad, use deltaY
                // Otherwise use fixed scroll speed
                deltaY = (this.scrollType === 'trackpad') ?
                    event.deltaY :
                    Math.sign(event.deltaY) * zoomVelocity;
                break;
            default: // Line delta (less common, mice scroll wheels in Firefox)
                this.scrollType = 'wheel';
                break;
        }
        // Reset checking tracker. After 500ms of inactivity, reset scroll tracker.
        // Do this so that users transitioning between mouse and trackpad don't have issues.
        clearTimeout(this.scrollTimeout);
        this.scrollTimeout = setTimeout(function () {
            _this.scrollType = null;
        }, 500);
        // Don't allow zoom to exceed max
        if (Math.abs(deltaY) > 40) {
            deltaY = Math.sign(deltaY) * 40;
        }
        // For trackpad, use pixel precision.
        if (this.scrollType === 'trackpad') {
            this.cameraService.setCameraZoom(deltaY);
            // For wheel, use fixed velocity
        }
        else {
            this.zoomWithVelocity(deltaY);
        }
    };
    EngineComponent.prototype.zoomWithVelocity = function (deltaY) {
        var _this = this;
        this.cameraService.setCameraZoom(deltaY);
        requestAnimationFrame(function () {
            deltaY *= 0.85;
            if (Math.abs(deltaY) > 1) {
                _this.zoomWithVelocity(deltaY);
            }
        });
    };
    EngineComponent.prototype.handleContextMenu = function (event) {
        event.preventDefault();
        var offsetX = event.offsetX, offsetY = event.offsetY;
        var hit = this.getHit(offsetX, offsetY);
        var node = this.getNodeFromHit(hit);
    };
    EngineComponent.prototype.handleTap = function (event) {
        var _a = this.getOffset(event), offsetX = _a.offsetX, offsetY = _a.offsetY;
        var hit = this.getHit(offsetX, offsetY);
        var node = this.getNodeFromHit(hit);
        this.store.dispatch(new ClickNode(node, event, hit));
    };
    EngineComponent.prototype.handleDoubleTap = function (event) {
        var _a = this.getOffset(event), offsetX = _a.offsetX, offsetY = _a.offsetY;
        var hit = this.getHit(offsetX, offsetY);
        var node = this.getNodeFromHit(hit);
        if (node) {
            this.store.dispatch(new FlyToObject(node.id));
        }
    };
    EngineComponent.prototype.handlePress = function (event) {
        var _a = this.getOffset(event), offsetX = _a.offsetX, offsetY = _a.offsetY;
        var hit = this.getHit(offsetX, offsetY);
        var node = this.getNodeFromHit(hit);
        if (node) {
            this.store.dispatch(new FlyToObject(node.id));
        }
    };
    EngineComponent.prototype.handlePan = function (event) {
        var panMode = this.store.selectSnapshot(EngineCameraState.getPanMode);
        if (event.srcEvent.shiftKey || panMode === 'pan') {
            var _a = event.srcEvent, movementX = _a.movementX, movementY = _a.movementY;
            movementX /= 20;
            movementY /= 20;
            this.cameraService.setCameraPan(movementX, movementY);
        }
        else {
            this.cameraService.setCameraRotation(event.velocityX * TouchCamera.Rotate, event.velocityY * TouchCamera.Rotate);
        }
    };
    EngineComponent.prototype.handleMouseInputEngineTick = function () {
        var rotation = this.cameraService.tickCameraRotation();
        var pan = this.cameraService.tickCameraPan();
        var zoom = this.cameraService.tickCameraZoom();
        // Rotation
        if (rotation.vx || rotation.vy) {
            this.cameraService.rotateCameraStatic(rotation.vx !== 0 ? rotation.vx * MouseCamera.Rotate : 0, rotation.vy !== 0 ? rotation.vy * MouseCamera.Rotate : 0);
        }
        // Pan
        if (pan.x || pan.y) {
            var f = Math.max(Human.renderer.camera.lookDistance / 80, 0.01);
            this.cameraService.panCameraStatic((pan.x * f) * MouseCamera.Pan, (pan.y * f) * MouseCamera.Pan, (pan.z * f) * MouseCamera.Pan);
        }
        // Zoom
        if (zoom !== 0) {
            this.cameraService.setHumanZoom(zoom * MouseCamera.Zoom);
        }
    };
    EngineComponent.prototype.handleCameraTick = function () {
        var motion = this.store.selectSnapshot(EngineCameraState.getCameraMotion);
        // PAN
        this.cameraService.setCameraPan(motion.panX, motion.panY);
        this.cameraService.setCameraRotation(motion.rotateX, motion.rotateY);
        this.cameraService.setCameraZoom(motion.zoom);
    };
    EngineComponent.prototype.flyToObject = function (objectId, animationDuration) {
        Human.renderer.camera.fly.flyTo({
            objectId: objectId,
            animationDuration: animationDuration
        });
    };
    EngineComponent.prototype.jumpToObject = function (objectId) {
        Human.renderer.camera.fly.jumpTo({ objectId: objectId });
    };
    EngineComponent.prototype.flyToPoint = function (destination, animationDuration) {
        Human.renderer.camera.fly.flyTo(__assign({}, destination, { animationDuration: animationDuration }));
    };
    EngineComponent.prototype.jumpToPoint = function (destination) {
        Human.renderer.camera.fly.jumpTo(destination);
    };
    EngineComponent.prototype.getNodeFromHit = function (hit) {
        var node;
        if (hit.objectId) {
            var viewGraph = this.store.selectSnapshot(EngineState.getViewGraph);
            node = this.engineEventsService.getNode(viewGraph, hit.objectId);
        }
        return node;
    };
    EngineComponent.prototype.getHit = function (x, y) {
        // For clicks, set rayPick to true so we get a completely detailed hit object
        // that includes the exact triangle the user clicked on. This is different 
        // from hover, that only target the general node. 
        var hit = Human.renderer.pick.pick(x, y, { rayPick: true });
        return hit;
    };
    EngineComponent.prototype.getContainerStyles = function () {
        var styles = {};
        // set background
        if (this.background && !this.isTransparentBackground) {
            styles['background-image'] = BackgroundModel.toCSS(this.background);
        }
        // set display
        if (!this.display) {
            styles['display'] = 'none';
        }
        // set transparent
        if (!this.engineVisible) {
            styles['opacity'] = 0;
        }
        return styles;
    };
    // We calculate offsetX and offsetY using rect and center because iOS safari
    // does not natively support offsetX and offsetY. Those properties return `undefined`
    // when requested. 
    // More: http://www.jacklmoore.com/notes/mouse-position/
    EngineComponent.prototype.getOffset = function (event) {
        var x = 0;
        var y = 0;
        if (event.center) {
            x = event.center.x;
            y = event.center.y;
        }
        else {
            x = event.clientX;
            y = event.clientY;
        }
        var target = this.engineElement.nativeElement;
        var rect = target.getBoundingClientRect();
        return {
            offsetX: x - rect.left,
            offsetY: y - rect.top
        };
    };
    EngineComponent.prototype.calculateSelectedObjectsUpdate = function (previouslySelected, currentlySelected) {
        var previousSelectedState = this.createNodeStateMap(previouslySelected, false);
        var currentlySelectedState = this.createNodeStateMap(currentlySelected, true);
        return __assign({}, previousSelectedState, currentlySelectedState);
    };
    EngineComponent.prototype.createNodeStateMap = function (nodes, state) {
        return nodes.reduce(function (acc, node) {
            acc[node.id] = state;
            return acc;
        }, {});
    };
    __decorate([
        Select(EngineState.getReady),
        __metadata("design:type", Observable)
    ], EngineComponent.prototype, "ready$", void 0);
    __decorate([
        Select(EngineState.getViewGraph),
        __metadata("design:type", Observable)
    ], EngineComponent.prototype, "viewGraph$", void 0);
    __decorate([
        Select(EngineState.getEnginePosition),
        __metadata("design:type", Observable)
    ], EngineComponent.prototype, "enginePosition$", void 0);
    __decorate([
        Select(EngineNodesState.getHoveredNode),
        __metadata("design:type", Observable)
    ], EngineComponent.prototype, "hoveredNode$", void 0);
    __decorate([
        Select(EngineState.getChapter),
        __metadata("design:type", Observable)
    ], EngineComponent.prototype, "chapter$", void 0);
    __decorate([
        Select(EngineState.getChapterInit),
        __metadata("design:type", Observable)
    ], EngineComponent.prototype, "chapterInit$", void 0);
    __decorate([
        Select(EngineNodesState.getCheckedNodes),
        __metadata("design:type", Observable)
    ], EngineComponent.prototype, "checkedNodes$", void 0);
    __decorate([
        Select(EngineState.getActiveTool),
        __metadata("design:type", Observable)
    ], EngineComponent.prototype, "activeTool$", void 0);
    __decorate([
        Select(EngineState.getAnimationPlaying),
        __metadata("design:type", Observable)
    ], EngineComponent.prototype, "animationPlaying$", void 0);
    __decorate([
        Select(EngineState.getDisplay),
        __metadata("design:type", Observable)
    ], EngineComponent.prototype, "engineDisplay$", void 0);
    __decorate([
        Select(EngineState.getVisible),
        __metadata("design:type", Observable)
    ], EngineComponent.prototype, "engineVisible$", void 0);
    __decorate([
        Select(StoryChaptersState.getSelectedChapter),
        __metadata("design:type", Observable)
    ], EngineComponent.prototype, "selectedChapter$", void 0);
    __decorate([
        Select(EngineCameraState.getCameraMotion),
        __metadata("design:type", Observable)
    ], EngineComponent.prototype, "cameraMotion$", void 0);
    __decorate([
        Select(StoryChaptersState.getSelectedChapterBackground),
        __metadata("design:type", Observable)
    ], EngineComponent.prototype, "background$", void 0);
    return EngineComponent;
}());
export { EngineComponent };
